export default {
    blue: '#778db6',
    pink: '#ffb3e8',
    green: '#c6f5eb',
    yellow: '#FDE530',
};